<template>
  <div class="container bg-light w-100">
    <div class="row justify-content-center">
      <div class="col col-md-6 col-xs-12">
        <div id="content" class="flex">
          <div class="d-flex flex align-items-center mh-v">
            <div class="text-center p-5 w-100">
              <svg v-if="message === 'Integration Connected Successfully!'" class="checkmark" viewBox="0 0 64 64">
                <circle cx="32" cy="32" r="30" fill="none" stroke="#4caf50" stroke-width="4" />
                <path fill="none" stroke="#4caf50" stroke-width="4" d="M20 34l8 8 16-18" />
              </svg>
              <h1 class="display-5 my-5">{{ message }}</h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import type { TokenData } from '@/types/Models/Account'
import { defineComponent, ref, type Ref } from 'vue'
import { useRoute } from 'vue-router'
import { useAuthStore } from '@/store/auth'
import { useCustomersIntegrationsStore } from '@/store/customers/integrations'

export default defineComponent({
  name: 'ConnectionSuccess',
  setup() {
    const customersIntegrationsStore = useCustomersIntegrationsStore()
    const route = useRoute()

    const authStore = useAuthStore()
    const message: Ref<string> = ref('Verifying...')

    customersIntegrationsStore
      .oauthCallback({ ...route.query })
      .then((response: TokenData) => {
        if (!response?.init) {
          message.value = 'Integration Connected Successfully! You can now close this window.'
        } else {
          message.value = 'Authentication successful! Redirecting to your account...'
          authStore.loginByToken(response.access_token)
        }
      })
      .catch(() => {
        message.value = 'Failed to connect integration. Please try again.'
      })

    return {
      message,
    }
  },
})
</script>
